import React, { useState } from 'react';
import Form from '../../components/common/Form';
import FormSection from '../../components/common/FormSection';
import FormField from '../../components/common/FormField';
import { CountryDTO } from '../../services/apiClient';
import handleChange from '../../utils/formUtils/handleChange';
import { useFormValidation, ValidationRules } from '../../hooks/useFormValidation';

interface CountryFormProps {
  initialValues: CountryDTO;
  onSubmit: (data: CountryDTO) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const FORM_SECTIONS = {
  basicInfo: {
    id: 'basic-info',
    title: 'Basic Information'
  }
} as const;

const CountryForm: React.FC<CountryFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const [formData, setFormData] = useState<CountryDTO>(initialValues);

  
            const validationRules: ValidationRules = {
                    name: [
      { required: true, message: 'Name is required' }
    ],
    code: [
      { required: true, message: 'Code is required' }
    ]
            };

  const { errors, validate } = useFormValidation<CountryDTO>(validationRules);

  const handleSave = () => {
    if (validate(formData)) {
      onSubmit(formData);
    }
  };

  const sections = Object.values(FORM_SECTIONS);

  return (
    <Form sections={sections} onSave={handleSave} onCancel={onCancel} isSubmitting={isLoading}>
      <FormSection 
        id={FORM_SECTIONS.basicInfo.id} 
        title={FORM_SECTIONS.basicInfo.title}
      >
                <FormField
          id="name"
          label="Name"
          type="text"
          value={formData.name || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Name"
          required={true}
          error={errors.name}
        />
        <FormField
          id="code"
          label="Code"
          type="text"
          value={formData.code || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Code"
          required={true}
          error={errors.code}
        />
        <FormField
          id="legacyCountryId"
          label="Legacy Country Id"
          type="text"
          value={formData.legacyCountryId || ''}
          onChange={(e) => handleChange(e, setFormData)}
          placeholder="Enter Legacy Country Id"
          required={false}
          error={errors.legacyCountryId}
        />

      </FormSection>
    </Form>
  );
};

export default CountryForm;